import React, { useState, useEffect } from 'react';
import { Card, Table, Button } from 'antd';
import { EditOutlined, PlusOutlined } from '@ant-design/icons';
import { useNavigate, useParams } from 'react-router-dom';
import axios from '../util/axiosConfig'
import '../styles/userlist.css'
import { usePagination } from '../context/PaginationProvider';

const ToleranceModificationLog: React.FC = () => {
    const { pagination, setTotal, setPage, setPageSize } = usePagination();
    const { page, pageSize, sort_by, sort_order } = pagination;
    const [toleranceMod, setToleranceMod] = useState<any>([]);
    const { id } = useParams<{ id: string }>();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [paginationConfig, setPaginationConfig] = useState({
        current: page,
        pageSize: pageSize,
        total: 0,
        showTotal: (total: number, range: [number, number]) => `Showing ${range[0]}-${range[1]} of ${total} entries`,
        showSizeChanger: true,
        pageSizeOptions: ["5", "10", "20", "50"],
        locale: { items_per_page: "" },
        onChange: (page: number, pageSize: number) => {
            setPage(page);
            setPageSize(pageSize);
            setPaginationConfig((prev: any) => ({
                ...prev,
                current: page,
                pageSize: pageSize,
            }));
        },
        onShowSizeChange: (current: number, size: number) => {
            setPage(current);
            setPageSize(size);
            setPaginationConfig((prev: any) => ({
                ...prev,
                current: current,
                pageSize: size,
            }));
        },
    });

    const fetchToleranceList = async () => {
        setLoading(true);
        try {
            const response = await axios.get(`/po-document-type/get-modification-logs/${id}`, {
                params: {
                    documentTypeId: id,
                    pageSize: pageSize,
                    pageNo: page - 1,
                    sortByField: sort_by,
                    sortDirection: 'desc',
                },
            });
            const content = response?.data?.data || [];
            if (Array.isArray(content)) {
                setToleranceMod(content);
                setTotal(response.data?.data?.totalElements || 0);
                setPaginationConfig((prev) => ({
                    ...prev,
                    total: response.data?.data?.totalElements || 0,
                }));
            } else {
                console.error('Unexpected response format:', response.data);
            }
        } catch (error) {
            console.error('Failed to fetch panel data', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchToleranceList();
        // eslint-disable-next-line
    }, [page, pageSize, sort_by, sort_order]);

    const handleEdit = (id: any, record: any) => {
        navigate(`/toleranceUpdate/${id}`);
    };

    const columns: any = [
        {
            title: 'Log No',
            dataIndex: 'logNo',
            key: 'logNo'
        },
        {
            title: 'Modified Field',
            dataIndex: 'modifiedField',
            key: 'modifiedField',
        },
        {
            title: 'Previous Value',
            dataIndex: 'previousValue',
            key: 'previousValue'
        },
        {
            title: 'Modified Value',
            dataIndex: 'modifiedValue',
            key: 'modifiedValue'
        },
        {
            title: 'Previous User',
            dataIndex: 'previousUser',
            key: 'previousUser'
        },
        {
            title: 'Modified User',
            dataIndex: 'modifiedUser',
            key: 'modifiedUser'
        },
        {
            title: 'Modified On',
            dataIndex: 'modifiedOn',
            key: 'modifiedOn'
        }
    ];

    return (
        <>
            <Card
                title="Tolerance List"
                bordered={false}
                extra={''}
            >
                <Table
                    loading={loading}
                    className='roleTable'
                    dataSource={toleranceMod}
                    columns={columns}
                    bordered={false}
                    pagination={paginationConfig}
                    size='small'
                />
            </Card>
        </>
    );
};

export default ToleranceModificationLog;
